import './infocard.css'
import { Box, Button, SxProps, Theme, Typography } from "@mui/material"
import { memo, useContext, useEffect, useMemo, useState } from 'react';
import InfoIconCarre from './iconInfo';
import { AppContext } from '../../../../contexts/AppContext';
interface Props {
    sx?:SxProps<Theme>
    min:number
    minUnite?:string
    max:number
    maxUnite?:string
    step?:number
    unite?:string
    showStepBtn?:boolean
    title:string
    defaultValue:number,
    needPrecision?:boolean,
    type?:string,
    name:string,
    isActive:string[],
    updateActive:(state:boolean)=>void,
    updatedValue?: (scale:number)=>void,
    toggleInfo?:()=>void,
    isSelected?:boolean
}

export const InfoCard = ({isSelected,updateActive, isActive,name,sx, type,min, minUnite, max, maxUnite, step, needPrecision, unite, showStepBtn, title, defaultValue, updatedValue,toggleInfo }: Props) => {
    const [ishover, setIshover] = useState<boolean>(false);

    const { server } = useContext(AppContext);

    const handleOnClick =(direction:number)=>{
        updatedValue?.((step??1)*direction)
    }

    const visible = useMemo(()=>{
        return server=="BETA"&&type?.includes("info")?true:false
    }, [server])

    return (
        <Box data-selected={isSelected?"1":""} sx={{margin:"0 1rem",...sx}} className={"info-card"+(((isActive.includes(name))||ishover)?" active":"")} onMouseEnter={()=>{setIshover(true);updateActive(true)}} onMouseLeave={()=>{setIshover(false);updateActive(false)}}>
            <Box sx={{display:"flex", justifyContent:"space-between"}} className="top">
                <Button className="serious-btn" variant="contained" sx={{minWidth:"unset !important",margin:"0 0.5rem 0 1rem", padding:"0 6px !important", display:(showStepBtn??true)?"block":"none"}} onClick={()=>{handleOnClick(-1)}}>-</Button>
                <Typography sx={{margin: "auto", display:visible?"none":"block"}}>{(needPrecision??false ? defaultValue.toFixed(1):defaultValue.toFixed(0))+(unite??"")}</Typography>
                <Button className="serious-btn" variant="contained" sx={{minWidth:"unset !important",margin:"0 1rem 0 0.5rem", padding:"0 6px !important",display:(showStepBtn??true)?"block":"none"}}  onClick={()=>{handleOnClick(1)}}>+</Button>
            </Box>
            <Box className={"body "+(type??"managment")}>
                <Typography sx={{margin: "auto", display:visible?"flex":"none !important"}}>{(needPrecision??false ? defaultValue.toFixed(1):defaultValue.toFixed(0))+(unite??"")}</Typography>

                <Box className="progress" height={"7.22px"} sx={{marginBottom:"4px", width:"100%", display:visible?'none':'block'}} >
                    <Box sx={{background:"black", position:"relative", height: "15.1px", width:"7.26px", left: Math.max(0,Math.min(100,(((defaultValue - min) / (max - min))*100)))+"%", top:"-3px"}}></Box>
                </Box>
                <Box sx={{display:visible?'none':'flex', justifyContent:"space-between", width:"100%"}}>
                    <Typography className='unite'>{minUnite}</Typography>
                    <Typography className='unite'>{maxUnite}</Typography>
                </Box>
                <Typography className='control-title' sx={{margin:"auto"}}>{title}</Typography>
                <Box sx={{display: "flex", justifyContent: "end",width: "100%"}}>
                    <InfoIconCarre onClick={()=>{toggleInfo?.()}} />
                </Box>
                
            </Box>
            
        </Box>
    )
}